import { render } from "./hot-circle.vue?vue&type=template&id=674b9fb7&scoped=true"
import script from "./hot-circle.vue?vue&type=script&lang=js"
export * from "./hot-circle.vue?vue&type=script&lang=js"

import "./hot-circle.vue?vue&type=style&index=0&id=674b9fb7&lang=scss&scoped=true"

import exportComponent from "/www/publicHouse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-674b9fb7"]])

export default __exports__